import Modal from "react-bootstrap/Modal";
import {useState, useContext} from "react";
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";

import axiApi from "ApiCaller";
import Form from "react-bootstrap/Form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import TableParameters from "./TableParameters";
import {publishEvent} from "core/eventsConnector";
import ConditionalRender from "components/ConditionalRender";
import AuthContext from "context/AuthContext";

const ItemModel = function () {
    return {
        value: "",
        name: "",
        topic: "",
        length: 0,
        parameters: "",
        message: "",
    };
};

const WordMessageModel = {
    currentBytes: 0,
    totalBytes: 0,
    sameBytes: false,
    length: 0,
    isValid: true,
    calculateLengths: function () {
        if (!this.value) {
            this.currentBytes = 0;
            this.length = 0;
        } else {
            this.length = this.value.length;
            this.currentBytes = this.value.includes(",") ? this.value.split(/,/).length : Math.ceil(this.length / 2);
        }
    },
};

const topicOptions = [
    {value: "/4g/admin/mq2", name: "Admin"},
    {value: "/4g/alerts/mq2", name: "Alerts"},
    {value: "/4g/control/mq2", name: "Control"},
    {value: "/4g/data/mq2", name: "Data"},
];

const ModalSendMessage = ({show, setShow}) => {
    const {user} = useContext(AuthContext);
    const numTopic = `${user.organization.client}-${user.panel.project}`;
    const Alert = new SwalAlertClass({confirmButtonText: "Accept"});

    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });

    const [item, setItem] = useState(new ItemModel());
    const [word, setWord] = useState({...WordMessageModel, value: ""});
    const [topicText, setTopicText] = useState(numTopic);

    const handleChangeSelect = (e) => {
        const selectedValue = e.target.value;
        setItem((prev) => ({...prev, topic: selectedValue}));
        setTopicText(`${numTopic}${selectedValue}`);
    };

    const handleWordInput = (e) => {
        const rawInput = e.target.value;
        let newValue = rawInput.replace(/\s+/g, " ");
        setWord((prev) => {
            const word_ = {...prev, value: newValue};
            word_.calculateLengths();
            return word_;
        });
    };

    const handleTopicTextInput = (e) => {
        const newValue = e.target.value;
        setTopicText(newValue);
        const foundTopic = topicOptions.find((opt) => newValue.endsWith(opt.value));
        if (foundTopic) {
            setItem((prev) => ({...prev, topic: foundTopic.value}));
        }
    };

    const handleClose = () => {
        setShow(false);
        setItem(new ItemModel());
        setWord({...WordMessageModel, value: ""});
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const topicLabel = topicOptions.find((opt) => opt.value === item.topic)?.name || item.topic;
        if (!item.topic) {
            Alert.error("Error", "Debe seleccionar un topic para enviar el mensaje.");
            return;
        }
        if (!word.value || word.value.length === 0) {
            Alert.error("Error", "Debe ingresar un mensaje para enviar.");
            return;
        }
        AlertQuestion.warning(`¿Desea enviar mensaje al topic ${topicLabel}?`).then((result) => {
            if (result.isConfirmed) {
                const item = {
                    topic: topicText,
                    payload: word.value,
                };
                axiApi.post("/api/devices/downs/send/message/", item);
                Alert.success("Solicitud", "Se ha encolado el mensaje para su envío.").then(() => {
                    publishEvent("reload:view:sender", {});
                    setItem(new ItemModel());
                    setShow(false);
                });
            }
        });
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} aria-modal={true} centered size="lg">
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="fa-cloud-arrow-up" />
                    </div>
                    <div className="preview-title d-inline-flex align-items-center">
                        <Modal.Title>Enviar mensaje</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={(e) => e.preventDefault()}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <p>Seleccione el topic al que desea enviar el mensaje.</p>
                                    <div className="row">
                                        <div className="col-md-6 d-flex flex-column justify-content-between">
                                            <div className="form-group mt-4">
                                                <label htmlFor="message">Topic</label>
                                                <select
                                                    className="form-control"
                                                    id="message"
                                                    onChange={handleChangeSelect}
                                                    value={item.topic}>
                                                    <option value="">Seleccionar un topic</option>
                                                    {topicOptions.map((item_, idx) => (
                                                        <option value={item_.value} key={idx}>
                                                            {item_.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mt-4">
                                                <label htmlFor="topic-text">Topic formato texto</label>
                                                <textarea
                                                    className="form-control"
                                                    id="topic-text"
                                                    value={topicText}
                                                    rows="1"
                                                    style={{resize: "vertical", minHeight: "38px", maxHeight: "80px"}}
                                                    onChange={handleTopicTextInput}
                                                />
                                                <small className="form-text text-muted">Caracteres: {topicText.length}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mt-4">
                                    <div className="form-group">
                                        <label htmlFor="message">Mensaje a enviar</label>
                                        <textarea className="form-control" id="message" rows="4" onChange={handleWordInput} />
                                        <small className="form-text text-muted">Caracteres: {word.value.length}</small>
                                    </div>
                                </div>
                                <ConditionalRender condition={item && item.parameters}>
                                    <div className="col-12 mt-4">
                                        <h6>Parametros</h6>
                                        <div className="row">
                                            <div className="col-6">
                                                <strong>Topic:</strong> {item.topic}
                                            </div>
                                            <div className="col-6 text-end">
                                                <span className="ms-auto">
                                                    <small className={word.isValid ? "text-success" : "text-danger"}>
                                                        {`Medida: ${word.currentBytes}/${word.totalBytes} bytes`}
                                                    </small>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <TableParameters item={item} word={word} setWord={setWord} />
                                        </div>
                                    </div>
                                </ConditionalRender>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={onSubmit}>
                        Enviar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalSendMessage;
